import axios from "axios";
import { Loading } from "element-ui";
import { Toast } from "vant";
import api from "./api";

const baseUrl = "/route/api";
const payUrl = "/route/pay";
//住院陪护凭证
const escortUrl = "/route/escort";
const baseApi = "/rest/";
const VacUrl = "/palmhospitalWebService";
const natUrl = "/api";

const apiInstance = axios.create({
  baseURL: baseUrl + baseApi,
  timeout: 20000
});

// 用于非 /rest 路径的接口（例如 refundQueryNew）
const apiNoRestInstance = axios.create({
  baseURL: baseUrl,
  timeout: 20000
});

const apiFilter = [
  api.TEST,
  api.USER_TOKEN_REFRESH,
  api.OTHER_DRUG_INTRUCTION_LIST,
  api.OTHER_DRUG_INTRUCTION_DETAIL
];

const payInstance = axios.create({
  baseURL: payUrl + baseApi,
  timeout: 20000
});
const vacInstance = axios.create({
  baseURL: VacUrl + baseApi,
  timeout: 20000
});

const natInstance = axios.create({
  baseURL: natUrl + baseApi,
  timeout: 20000
});

const escortInstance = axios.create({
  baseURL: escortUrl + baseApi,
  timeout: 20000
});

let token = "";

function getQueryVariable(variable) {
  if (!window.location && !window.location.hash) return "";
  var query = window.location.hash.split("?")[1];
  if (!query) return "";
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function getToken() {
  if (!token) {
    const urlToken = getQueryVariable("token");
    if (urlToken) {
      localStorage.setItem("token", urlToken);
      token = urlToken;
    }
    const urlRefreshToken = getQueryVariable("refreshToken");
    if (urlRefreshToken) {
      localStorage.setItem("refreshToken", urlRefreshToken);
    }
  }
  if (!token) {
    token = localStorage.getItem("token");
  }
  return token;
}

const loadingOptions = {
  lock: true,
  text: "加载中，请耐心等待",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.7)"
};

function isPaymentApi(url) {
  return (
    [
      api.RECHARGE_PAYMENT_COMMIT,
      api.RECHARGE_PAYMENT_RECORDS,
      api.GET_ORDER_FORMNO
    ].indexOf(url) >= 0
  );
}

function isNatApi(url) {
  return (
    [
      api.TEST_NUCLEIC_ACID_PROFESSION,
      api.TEST_NUCLEIC_ACID_COMMIT,
      api.TEST_NUCLEIC_ACID_USERINFO,
      api.TEST_IS_JD,
      api.TEST_CREAT_FILE,
      api.TEST_REOPEN,
      api.TEST_CARD_LIST,
      api.TEST_GET_QUERY,
      api.TEST_GET_PATIENT,
      api.TEST_GET_PROFESSION,
      api.TEST_GET_CJD,
      api.TEST_ADD_ORDER,
      api.TEST_GET_BGCX,
      api.TEST_GET_MANUAL_LIST,
      api.TEST_REPORT_LIST,
      // api.TEST_GET_REPORT_DETAIL,
      api.GET_HS_ORDER_AMOUNT
      // api.PUSH_GET_LIST,
      // api.PUSH_ADD_SET,
      // api.PUSH_DELETE,
      // api.PUSH_PUSH,
      // api.PUSH_LOGIN,
      // api.PUSH_GET_PICCODE,
      // api.PUSH_GET_PHONECODE
    ].indexOf(url) >= 0
  );
}

function isVacApi(url) {
  return (
    [
      api.VAC_GATDATE,
      api.VAC_GET_QTY,
      api.VAC_REG,
      api.VAC_CONSULT,
      api.VAC_CANCEL,
      api.TEST_PATIENT_BYID
      // api.TEST_GET_BASEINFO
    ].indexOf(url) >= 0
  );
}

function isEscortmentApi(url) {
  return (
    [
      api.ESCORTPEOPLE_LIST,
      api.ESCORTPEOPLE_ADD,
      api.ESCORTPEOPLE_UPDATE,
      api.ESCORTPEOPLE_SENMSG,
      api.ESCORTPEOPLE_START,
      api.ESCORTPEOPLE_STOP,
      api.ESCORTPEOPLE_UPLOAD,
      api.ESCORTPEOPLE_DEL,
      api.ESCORTPEOPLE_GETRECORD,
      api.ESCORTPEOPLE_ADDSURVEY,
      api.ESCORTPEOPLE_CARD_LIST
    ].indexOf(url) >= 0
  );
}

// 非 /rest 接口（走 /route/api），如 refundQueryNew 下的接口
function isNoRestApi(url) {
  return [
    api.SEND_VERIFY_CODE,
    api.QUERY_CARD_LIST_BY_SMSCODE,
    api.REFUNDPATIENT_BASEINFO
  ].indexOf(url) >= 0;
}

function getInstance(url) {
  console.log(url);
  if (isNoRestApi(url)) {
    return apiNoRestInstance;
  }
  if (isPaymentApi(url)) {
    return payInstance;
  }
  if (isVacApi(url)) {
    return vacInstance;
  }
  if (isNatApi(url)) {
    return natInstance;
  }
  if (isEscortmentApi(url)) {
    return escortInstance;
  }
  return apiInstance;
}

function post(url, param, needLoading = true) {
  let loadingInstance = null;
  if (needLoading) {
    loadingInstance = Loading.service(loadingOptions);
  }
  const params = {
    ...param
  };
  if (apiFilter.indexOf(url) < 0) {
    params.token = getToken();
  }

  return new Promise((resolve, reject) => {
    console.log(url);
    const instance = getInstance(url);
    instance
      .post(url, params)
      .then(res => {
        if (res.data.success) {
          resolve(res.data.entity);
        } else if (
          res.data.message === "token超时失效" ||
          res.data.message === "token无效"
        ) {
          refreshToken(url, param, resolve);
        } else {
          if (res.data.errorCode === "501" || res.data.errorCode === "502") {
            reject(res.data);
          } else {
            alert(res.data.message);
            reject(res.data);
          }
        }
      })
      .catch(error => {
        let { status } = error.response;
        if (status > 404 && status < 600) {
          Toast("服务异常，请稍后重试");
        } else {
          reject(error);
        }
      })
      .finally(() => {
        if (loadingInstance) {
          loadingInstance.close();
        }
      });
  });
}

function upLoad(url, params, header) {
  return new Promise((resolve, reject) => {
    const instance = getInstance(url);
    instance
      .post(url, params, header)
      .then(res => {
        resolve(res.data.entity);
      })
      .catch(err => {
        reject(err);
      });
  });
}

function refreshToken(url, params, resolve) {
  const refToke = localStorage.getItem("refreshToken");
  post(api.USER_TOKEN_REFRESH, {
    refreshToken: refToke
  }).then(res => {
    localStorage.setItem("refreshToken", res.refreshToken);
    localStorage.setItem("token", res.token);
    /* eslint-disable prefer-destructuring */
    token = res.token;
    post(url, {
      ...params,
      token
    }).then(result => {
      resolve(result);
    });
  });
}

function get() {}

function configPost(url, params) {
  return new Promise(resolve => {
    axios.post(baseUrl + url, params).then(res => {
      resolve(res.data.entity);
    });
  });
}

function route(url, type, params, replace = false) {
  var routeUrl = `${baseUrl}${url}?token=${token}&functionType=${type}${params ||
    ""}`;
  if (replace) {
    window.location.replace(routeUrl);
  } else {
    window.location.href = routeUrl;
  }
}

export default {
  get,
  post,
  upLoad,
  api,
  route,
  configPost
};
